import isNull from 'lodash/isNull'

export default class Accordion {
    constructor() {
        this.cacheDom()
        this.bindEvents()
    }

    cacheDom() {
        this.accordions = document.querySelectorAll('.accordion')
        this.toggle = document.querySelectorAll('.accordion-header')
    }

    bindEvents() {
        if (!isNull(this.toggle)) {
            Array.prototype.forEach.call(this.toggle, (element) => {
                element.addEventListener('click', this.toggleAccordion.bind(this))
            })
        }
    }

    toggleAccordion(event) {
        const parent = event.target.parentNode
        const panel = event.target.nextElementSibling
        const previous = parent.previousElementSibling
        let timeout = 0

        if (parent.classList.contains('is-open')) {
            this.close()
        } else {
            if (previous && previous.classList.contains('is-open')) {
                timeout = 600
                
                // Scroll to previous active accordion
                window.scrollTo({
                    top: (previous.getBoundingClientRect().top + window.scrollY) - 100,
                    behavior: 'smooth'
                })

                // Close previous accordion
                setTimeout(this.close.bind(this), 200);
            } else {
                this.close()
            }

            // Scroll and open selected accordion
            setTimeout(() => {
                window.scrollTo({
                    top: (parent.getBoundingClientRect().top + window.scrollY) - 100,
                    behavior: 'smooth'
                })
                panel.style.maxHeight = panel.scrollHeight + 'px'
                parent.classList.add('is-open')
            }, timeout)
        }
    }

    close() {
        Array.prototype.forEach.call(this.accordions, (accordion) => {
            if (accordion.classList.contains('is-open')) {
                const panel = accordion.querySelector('.accordion-panel')
                accordion.classList.remove('is-open')
                panel.style.maxHeight = 0
            }
        })
    }
}
